var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pageloader is-active" }, [
      _c("span", { staticClass: "title has-text-white" }, [
        _vm._v("\n    Verificando token...\n  ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }